import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_plan_pago.docx): el modal
// es una vista previa, así que lo que se lee acá tiene que coincidir renglón por renglón
// con el papel. `guardable` marca los que además de imprimirse vuelven al cliente/trámite
// (ver CaratulaPlanPagoDocumentoService.persistirDatosGuardables).
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    pacto: { label: 'PACTO', tipo: 'sino' },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    nacionalidad: { label: 'NACIONALIDAD', tipo: 'texto', guardable: true },
    domicilio: {
        label: 'DOMICILIO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    domicilioReal: {
        label: 'DOMICILIO REAL', tipo: 'domicilio', estructurado: 'domicilioRealDatos', guardable: true,
        nota: 'Se guarda en el domicilio REAL del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono1: {
        label: 'Nº TELEFONICO 1)', tipo: 'texto',
        nota: 'El teléfono propio del cliente. Se edita desde su ficha.',
    },
    telefono2: {
        label: '2)', tipo: 'texto',
        nota: 'Los contactos adicionales del cliente. Se editan desde su ficha; lo que escribas acá va solo al documento.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },

    relacionDependencia: { label: 'RELACION DE DEPENDENCIA', tipo: 'texto' },
    autonomoMonotributo: { label: 'AUTONOMO O MONOTRIBUTO', tipo: 'texto' },
    aportesProvincia: { label: 'APORTES PROVINCIA', tipo: 'sino', guardable: true },
    cuentaAfip: { label: 'CUENTA EN AFIP', tipo: 'texto', guardable: true },
    planesVigentes: { label: 'PLANES VIGENTES', tipo: 'texto', guardable: true },

    cantidadHijos: {
        label: 'CANTIDAD DE HIJOS', tipo: 'texto',
        nota: 'Se cuenta sobre los hijos cargados en el cliente. Editarlo acá no los modifica.',
    },
    hijosAuh: {
        label: 'AUH', tipo: 'texto',
        nota: 'Se cuenta sobre los hijos cargados en el cliente. Editarlo acá no los modifica.',
    },
    hijosCud: {
        label: 'CON CUD', tipo: 'texto',
        nota: 'Se cuenta sobre los hijos cargados en el cliente. Editarlo acá no los modifica.',
    },
    iniciarJubilacion: { label: 'INICIAR JUBILACION', tipo: 'texto', guardable: true },
};

// Una sola plantilla, así que la distribución es fija (a diferencia de Jubilación y
// Reajuste, que eligen entre dos LAYOUTS). Un array de 1 key = renglón simple; de 2 o 3 =
// esa misma cantidad de columnas, tal como están en el papel.
const CAJAS_CABECERA = [['ingreso', 'pacto']];
const FILA_CLAVES = ['claveFiscal', 'claveCvss'];
const FILA_REFERENCIA = ['referencia'];
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['nacionalidad'],
    ['domicilio'],
    ['domicilioReal'],
    ['telefono1', 'telefono2'],
    ['mail'],
    ['estadoCivil'],
    ['relacionDependencia'],
    ['autonomoMonotributo'],
    ['aportesProvincia'],
    ['cuentaAfip'],
    ['planesVigentes'],
    ['cantidadHijos', 'hijosAuh', 'hijosCud'],
    ['iniciarJubilacion'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en las ocho carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: (
        <>
            1- REGULARIZACION DE UPDP: AHORA
            <br />
            2- Jubilación Ley 24241
        </>
    ),
    cabecera: CAJAS_CABECERA,
    filasPrevias: [FILA_CLAVES, FILA_REFERENCIA],
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula de Plan de Pago. Muestra los renglones prellenados (lo que ya está en el
 * cliente/trámite, o calculado desde los aportes) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y
 * emite el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaPlanPago(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de Plan de Pago"
            nombreDocumento="la Carátula de Plan de Pago"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
